<template>
  <div>
    <CardProcesso :processo="processo"/>

    <div v-if="temProcessos" class=" p-1 col-12 md:col-12  h-2rem card">
      <div>
        <label for="Minimo" class=" mb-0 font-bold w-max col-5 md:col-2 text-bold">
          Total de inscrições:
        </label>
        {{ getTotalInscricoes() }}
      </div>
    </div>

    <div>
      <Toolbar class="mb-4">
        <template #end>
          <Button label="Exportar" icon="pi pi-upload" class="p-button-help" @click="exportCSV()"/>
        </template>
      </Toolbar>
    </div>

    <TabView v-if="temProcessos">
      <TabPanel v-for="estadoInscricao in estados" v-bind:key="estadoInscricao.cod" :header="headerByEstado(estadoInscricao)">
        <div class="grid crud-demo">
          <ProgressSpinner v-if="inscricoesByEstado.length <= 0" />

          <div class="col-12" v-else>
            <div class="card">
              <Toast />
              <DataTable
                ref="dt"
                :value="inscricoesByEstado[estadoInscricao.cod]"
                :selection.sync="selectedinscricoes"
                dataKey="codInscricao"
                :paginator="true"
                :rows="10"
                :filters.sync="filters" filterDisplay="row"
                paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink CurrentPageReport RowsPerPageDropdown"
                :rowsPerPageOptions="[5, 10, 25]"
                currentPageReportTemplate="{first} a {last} de {totalRecords} inscrições"
                class="p-datatable-customers">
                <template #header>
                  <div class="table-header">
                    <h5 class="m-0">Inscrições</h5>
                    <div class="col-12 md:col-6">

                    </div>
                    <!-- span class="p-input-icon-left" v-if="processo.tipoSelecao.residencia">
                      <Checkbox v-model="filtroIsentoPagamento" id="isentoPagamento" :binary="true" />
                      <label class="font-bold"> Isento de Pagamento</label>
                    </span -->
                    <span class="p-input-icon-left">
                      <i class="pi pi-search" />
                      <InputText v-model="filters['global'].value" placeholder="Filtrar..."/>
                    </span>
                  </div>
                </template>
                <Column headerStyle="width:100%" field="nomeArea" header="Área" sortable/>
                <Column header="Candidato com deficiência" field="candidatoDeficiencia" sortable/>
                <Column header="Atendimento Especial" field="atendimento_especial" filterField="atendimento_especial" sortable>
                  <template #body="slotProps">
                    {{ slotProps.data.atendimento_especial ? 'Sim' : 'Não' }}
                  </template>
                  <template #filter="{filterModel, filterCallback}">
                    <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()"/>
                  </template>
                </Column>
                <Column field="codInscricao" header="Inscrição" sortable/>
                <Column field="usuarioNome" header="Candidato" sortable/>
                <Column field="coefic_red_escolar" header="Coeficiente de rendimento" sortable v-if="processo.tipoSelecao.estagio"/>
                <Column field="isentoPagamento" header="Isento" filterField="isentoPagamento" sortable v-if="processo.tipoSelecao.residencia">
                  <template #body="slotProps">
                    {{ slotProps.data.isentoPagamento ? 'Sim' : 'Não' }}
                  </template>
                  <template #filter="{filterModel, filterCallback}">
                    <TriStateCheckbox v-model="filterModel.value" @change="filterCallback()"/>
                  </template>
                </Column>
                <Column>
                  <template #body="slotProps">
                    <Button
                      v-if="podeAlterarInscricao"
                      icon="pi pi-pencil"
                      class="p-button-rounded p-button-success mr-2"
                      @click="openInscricao(slotProps.data, true)"/>
                    <Button
                      v-if="!podeAlterarInscricao"
                      icon="pi pi-file"
                      class="p-button-rounded p-button-secondary mr-2"
                      @click="openInscricao(slotProps.data, false)"/>
                  </template>
                </Column>
              </DataTable>

              <Dialog :visible.sync="inscricaoDialog" :style="{ width: '1000px' }" header="Detalhes da Inscrição" :modal="true" class="p-fluid">
                <Message v-for="msg of messages" :severity="msg.severity" :key="msg.content">
                  {{ msg.content }}
                </Message>

                <div class="grid p-fluid">
                  <div class="field col-12 md:col-4">
                    <label for="inscricao" class="font-bold">Inscrição</label>
                    <InputText
                      id="inscricao" v-model.trim="inscricao.codInscricao" disabled="true"/>
                  </div>
                  <div class="field col-12 md:col-8">
                    <label for="candidato" class="font-bold">Candidato</label>
                    <InputText
                      id="candidato" v-model.trim="candidato" disabled="true"/>
                  </div>
                </div>

                <ValidationObserver v-slot="{ handleSubmit }">
                  <form id="fromValidarInscricao" @submit.prevent="handleSubmit(validarInscricao)" >
                  <div class="grid p-fluid" :class="{ 'p-disabled' : !flagEditarInscricao }">
                    <div class="field col-12 md:col-8">
                      <label for="area" class="font-bold ">
                        Área:
                      </label>
                      <InputText id="area" v-model="inscricao.nomeArea" disabled="true"/>
                    </div>

                    <div class="field col-12 md:col-4" v-if="processo.tipoSelecao.estagio">
                      <label for="Coeficiente de rendimento escolar" class=" font-bold required ">
                        Coeficiente mínimo de rendimento escolar
                      </label>
                      <ValidationProvider name="Coeficiente mínimo de rendimento escolar" rules="required|min_value:1|max_value:10"
                                          v-slot="{ errors }" mode="lazy">
                        <InputNumber id="coefic_red_escolar" v-model="inscricao.coefic_red_escolar"
                                      style=" text-align: right" mode="decimal" locale="de-DE" :minFractionDigits="2"/>
                        <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                      </ValidationProvider>
                    </div>
                  </div>

                  <!-- Informações de Instituição -->
                  <div class="grid p-fluid" v-if="processo.tipoSelecao.estagio">
                    <div class="field col-12 md:col-8">
                      <label for="instituicaoEnsino" class="font-bold">Instituição de Ensino Atual</label>
                      <Dropdown id="instituicaoEnsino" class="p-disabled" v-model="inscricao.instituicaoEnsino" :options="listaInstiuicao"  optionLabel="descricao"/>
                    </div>

                    <div class="field col-12 md:col-4">
                      <label for="coeficiente" class="font-bold required">Quantidade de Horas Cursadas</label>
                      <ValidationProvider name="Quantidade de Horas Cursadas" rules="required" v-slot="{ errors }" mode="lazy">
                          <InputNumber id="horasCursadas" v-model="inscricao.horasCursadas"
                                      mode="decimal" locale="pt-BR"
                                      :minFractionDigits="0" :maxFractionDigits="0"/>
                          <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                      </ValidationProvider>
                    </div>

                  </div>

                  <div class="grid p-fluid" :class="{ 'p-disabled' : !flagEditarInscricao }">
                    <div class="field col-12 md:col-3">
                      <label for="defi" class="font-bold ">Possui algum tipo de deficiência?</label>
                      <ValidationProvider name="defi" v-slot="{ errors }" mode="lazy">
                        <Dropdown id="defi" v-model="inscricao.concorreVagasReservadas" :options="dropdownValuesEsp"
                          modelValue="aaaa" optionLabel="label" :class="{ 'field-invalid': errors[0] }" @change="setMensagem(selectedEstado)"/>
                        <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                      </ValidationProvider>
                    </div>

                    <div class="field col-12 md:col-6" :class="{ 'p-disabled' : processo.analiseDocumental }">
                      <label for="atendimento_especial" class="font-bold ">Necessita de condições especiais para a realização da prova?</label>
                      <ValidationProvider name="atendimento_especial" v-slot="{ errors }" mode="lazy">
                        <Dropdown id="atendimento_especial" v-model="inscricao.atendimento_especial" :options="dropdownValuesEsp"
                                  :class="{ 'field-invalid': errors[0] }" optionLabel="label"/>
                        <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                      </ValidationProvider>
                    </div>

                    <div class="field col-12 md:col-3" v-if="inscricao.atendimento_especial" :class="{ 'p-disabled' : processo.analiseDocumental }">
                      <label for="salaExtra" class="font-bold required">Necessita de sala individual? </label>
                      <ValidationProvider name="salaExtra" rules="required" v-slot="{ errors }" mode="lazy">
                        <Dropdown id="salaExtra" v-model="inscricao.salaExtra" :options="dropdownValues" :class="{ 'field-invalid': errors[0] }"/>
                        <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                      </ValidationProvider>
                    </div>

                    <div class="field col-12 md:col-3" v-if="processo.tipoSelecao.residencia" :class="{ 'p-disabled' : processo.analiseDocumental }">
                      <label for="salaExtra" class="font-bold">Isento de pagamento?</label>
                      <ValidationProvider name="salaExtra" v-slot="{ errors }" mode="lazy">
                        <Dropdown id="isentoPagamento" v-model="inscricao.isentoPagamento" :options="dropdownValuesEsp" optionValue="value"
                                  optionLabel="label" :class="{ 'field-invalid': errors[0] }"/>
                        <InlineMessage v-if="errors[0]">{{errors[0]}}</InlineMessage>
                      </ValidationProvider>
                    </div>

                  </div>

                  <div class="grid p-fluid" :class="{ 'p-disabled' : !flagEditarInscricao }">
                    <div class="col-12 md:col-12" v-if="inscricao.atendimento_especial ? inscricao.atendimento_especial.value : false">
                      <label for="area" class="font-bold ">Descrição de atendimento especial para a prova escrita: </label>
                      <Textarea v-model="inscricao.desc_atend_especial" rows="5" cols="30" disabled class="mt-2 "/>
                    </div>
                  </div>

                  <!-- div class="grid p-fluid" v-if="inscricao.isentoPagamento">
                    <label for="area" class="col-12 md:col-12 font-bold">* Fui declarado isento de pagamento pelo Tribunal de Contas do Estado</label>
                  </div -->

                  <div class="field grid p-fluid">
                    <label for="area" class="col-12 md:col-12 font-bold">Documentos</label>
                    <div class="col-12 md:col-3 mb-2" v-if="inscricao.concorreVagasReservadas">
                      <Button id="download_comprovante_rg" label="Autodeclaração PCD" icon="pi pi-download"
                              @click="download(inscricao.id.usuario.comprovante_deficiencia.id, 'Autodeclaração PCD')"
                              class="p-button-info"
                              :disabled="!inscricao.permitirDowloadLaudoMedico">
                      </Button>
                    </div>
                    <div class="col-12 md:col-3 mb-2">
                      <Button id="download_comprovante_rg" label="Documento de identidade oficial com foto" icon="pi pi-download"
                              @click="download(inscricao.id.usuario.comprovante_rg.id,'Documento de identidade')"
                              class="p-button-info">
                      </Button>
                    </div>
                    <div class="col-12 md:col-3 mb-2" v-if="inscricao.id.selecaoEstagio.tipoSelecao.estagio">
                      <Button id="download_comprovante_mat" label="Declaração da faculdade" icon="pi pi-download"
                              @click="download(inscricao.idDoccomprovanteMatId,'Comprovante de matricula')"
                              class="p-button-info">
                      </Button>
                    </div>
                    <div class="col-12 md:col-3 mb-2" v-if="inscricao.id.selecaoEstagio.tipoSelecao.estagio">
                      <Button id="download_comprovante_red_escolar"  label="Histórico escolar" icon="pi pi-download"
                              @click="download(inscricao.idDocComprovanteRedEscolarId, 'Historico escolar')"
                              class="p-button-info">
                      </Button>
                    </div>
                    <div class="col-12 md:col-3 mb-2" v-if="inscricao.id.selecaoEstagio.tipoSelecao.residencia" :class="{ 'p-disabled' : inscricao.isentoPagamento}">
                      <Button id="download_comprovante_pagamento"  label="Comprovante de Pagamento" icon="pi pi-download"
                              @click="download(inscricao.idDocComprovantePagamento, 'Comprovante de Pagamento')"
                              class="p-button-info">
                      </Button>
                    </div>
                  </div>

                  <div class="grid col-12 md:col-12" :class="{ 'p-disabled' : !flagEditarInscricao }">
                      <label class="font-bold required mr-4">Estado Inscrição:</label>
                      <div v-for="estado of estados" :key="estado.id">
                        <RadioButton :id="estado.id"  :value="estado" v-model="selectedEstado" @click="setMensagem(estado)"
                                     :class="{ 'p-disabled' : estado.pendenteInscricao && processo.analiseDocumental}"/>
                        <label :for="estado.id" class="mr-4" :class="{ 'p-disabled' : estado.pendenteInscricao && processo.analiseDocumental}">{{estado.descricao}}</label>
                      </div>
                  </div>

                  <div class="grid col-12 md:col-12" :class="{ 'p-disabled' : !flagEditarInscricao }">
                    <ValidationProvider name="Mensagem" rules="required|min:10" v-slot="{ errors }" mode="lazy">
                      <label for="mensagem" class="font-bold required mr-4">Mensagem</label>
                      <span class="message-counter p-disabled">{{ inscricao.mensagem.length }} / 2000</span>
                      <Textarea id="mensagem" v-model="inscricao.mensagem" rows="4" cols="140" class=" mt-2" maxlength="2000" />
                      <InlineMessage v-if="errors[0]">{{ errors[0] }}</InlineMessage>
                    </ValidationProvider>
                  </div>
                  </form>
                </ValidationObserver>

                <ListaMensagensInscricao :lista.sync="listaMensagem"/>
                <br>
                <lista-logs :lista.sync="listaLogs"/>

                <template #footer>
                  <Button
                    label="Salvar"
                    type="submit"
                    form="fromValidarInscricao"
                    icon="pi pi-check"
                    class="p-button-text"
                    @click="inicializarIncricoes"
                    v-if="flagEditarInscricao"/>
                  <Button
                    label="Cancelar"
                    icon="pi pi-times"
                    class="p-button-text"
                    @click="hideDialog"/>
                </template>
              </Dialog>
            </div>
          </div>
        </div>
      </TabPanel>
    </TabView>
  </div>
</template>

<script>
import InscricaoService from "../../service/InscricaoService";
import EstadoInscricaoService from "../../service/EstadoInscricaoService";
import AreaProcessoService from "../../service/AreaProcessoService";
import LogService from "../../service/LogService";
import http from "@/http";
import { tratamentoDeErros } from "@/tratamentoDeErros";
import ProgressSpinner from "primevue/progressspinner";
import { validacaoFormulario } from "@/validacaoFormulario";
import CardProcesso from "../../components/CardProcesso.vue";
import { FilterMatchMode } from "primevue/api";
import ProcessoService from "../../service/ProcessoService";

import ListaLogs from "../../components/log/ListaLogs.vue";
import ListaMensagensInscricao from "../../components/inscricao/ListaMensagensInscricao.vue";

export default {
  components: { ProgressSpinner, CardProcesso, ListaLogs, ListaMensagensInscricao },

  mixins: [tratamentoDeErros, validacaoFormulario],

  data() {
    return {
      token: this.$store.state.token,
      temProcessos: false,
      processo: [],
      messages: [],
      dropdownValuesEsp: [{label:"Não",value:false}, {label:"Sim",value:true}],
      dropdownValues: ["Não", "Sim"],
      inscricao: {
        id: null,
        codInscricao: "",
        candidato: "",
        coefic_red_escolar: null,
        comprovante_red_escolar_id: null,
        estado: "",
        mensagem: "",
        nomeArea: "",
      },
      inscricaoService: null,
      estadoInscricaoService: null,
      logService: null,
      candidato: "kerisson",
      inscricaoAntes: null,
      inscricoes: null,
      listaMensagem: [],
      inscricoesByEstado: [],
      inscricaoDialog: false,
      deleteinscricaoDialog: false,
      deleteinscricoesDialog: false,
      product: {},
      selectedinscricoes: null,
      filters: {},
      submitted: false,
      selectedEstado: null,
      estados: null,
      mensagens: [
        "Sua inscrição foi recebida e está aguardando a análise dos dados e da documentação informados.",
        "Não foi possível confirmar os dados informados. Certifique-se de que...",
        "Sua inscrição foi deferida e você está habilitado para as demais etapas do processo seletivo.",
        "Sua inscrição foi rejeitada.",
      ],
      processoService: null,
      areaService: null,
      listaArea: [],
      mensagemAlterarDeficiencia: "Sua inscrição foi deferida e você está habilitado para as demais etapas do processo seletivo. Devido à incompletude de informações que atestem devidamente a espécie, o grau ou o nível da deficiência, com expressa referência ao código correspondente da Classificação Internacional de Doença - CID10, você está concorrendo às vagas gerais desse processo seletivo.",
      listaLogs: [],
      podeAlterarInscricao: false,
      flagEditarInscricao: false,
      listaInstiuicao:[],
    };
  },

  created() {
    this.inscricaoService = new InscricaoService();
    this.estadoInscricaoService = new EstadoInscricaoService();
    this.processoService = new ProcessoService();
    this.areaService = new AreaProcessoService();
    this.logService = new LogService();
    this.initFilters();
  },

  mounted() {
    this.processo = this.$store.state.processoSelecionado;
    this.inicializarIncricoes();

    this.inscricaoService.getListaIntituicoes()
                    .then((resposta) => {
                        this.listaInstiuicao = resposta;
                    });

  },

  watch : {
    processoSelecionado() {
      console.log("wath processo selecionado");
      this.processo = this.$store.state.processoSelecionado;
      this.inicializarIncricoes();
    },
  },

  computed: {
    processoSelecionado: {
      get() {
        return this.$store.state.processoSelecionado;
      },
    },
    filtroIsentoPagamento: {
      get() {
        return this.filters['isentoPagamento'].value;
      },
      set(value) {
        this.filters['isentoPagamento'].value = value ? value : null;
      }
    }
  },

  methods: {
    initFilters() {
      this.filters = {
        global: { value: null, matchMode: FilterMatchMode.CONTAINS },
        isentoPagamento: { value: null, matchMode: FilterMatchMode.EQUALS},
        candidatoDeficiencia: { value: null, matchMode: FilterMatchMode.EQUALS},
        atendimento_especial: { value: null, matchMode: FilterMatchMode.EQUALS},
      };
    },
    inicializarIncricoes() {
      this.$store.state.dlgLoading = true;
      this.processoService.getProcesso(this.processoSelecionado.id)
          .then((resposta) => {
            this.processo = resposta;
            this.processo.datHoraFimInscricao = this.$formatarDataHoraBR(this.processo.datHoraFimInscricao);
            this.processo.datHoraInicioInscricao = this.$formatarDataHoraBR(this.processo.datHoraInicioInscricao);
            this.temProcessos = true;
            this.podeAlterarInscricao = this.processo.estadoSelecao.podeValidarInscricao;
            this.inscricaoService.getInscricaoByIdprocesso(this.processo.id).then((inscricoes) => {
                          this.inscricoes = inscricoes;
                          this.setInscricoesByEstado();
                          this.$store.state.dlgLoading = false;
                        });
            this.estadoInscricaoService.getEstadosInscricao()
                .then((estados) => (this.estados = estados));
          });
    },

    getListaLogs(identificador) {
      this.logService.listarLogInscricao(identificador).then((data) => this.listaLogs = data);
    },

    headerByEstado(estadoInscricao) {
      let quantidade = this.inscricoesByEstado[estadoInscricao.cod]
        ? this.inscricoesByEstado[estadoInscricao.cod].length
        : 0;
      return `${estadoInscricao.descricao} (${quantidade})`;
    },

    hideDialog() {
      this.inscricaoDialog = false;
      this.submitted = false;
    },

    validarInscricao() {
      let parametro = this.inscricao;
      parametro.estadoInscricao = this.selectedEstado;
      parametro.concorreVagasReservadas = this.inscricao.concorreVagasReservadas.value;
      parametro.atendimento_especial = this.inscricao.atendimento_especial.value;
      parametro.username = this.$store.state.username;

      this.inscricaoService.update(parametro)
          .then((data) => { this.$toast.add({
                            severity: "success",
                            summary: "Sucesso",
                            detail: `Inscrição ${this.inscricao.codInscricao} de candidato ${this.candidato} foi atualizada com sucesso`,
                            life: 3000,
                          });
                  this.hideDialog();

                  console.log(data);

                  var index = this.findIndexById(this.inscricao.identificador);
                  console.log(index);
                  this.inscricoes.splice(index, 1, data);

                  this.inscricaoDialog = false;
                  this.inscricao = {};
                  this.setInscricoesByEstado();})
          .catch((erro) => {
                  this.messages = this.getMessagesError(erro);
          });
    },
    viewInscricao(inscricaoSelecionada){
      this.openInscricao(inscricaoSelecionada, false);
    },
    openInscricao(inscricaoSelecionada, editar) {
      this.$store.state.dlgLoading = true;
      this.flagEditarInscricao = editar;
      this.getListaLogs(inscricaoSelecionada.identificador);
      this.inscricaoService.getInscricaoDetalhadaById(inscricaoSelecionada.identificador)
          .then((dto) => {
            // console.log(inscricao);
            this.listaMensagem = dto.listaMensagem;
            this.inscricao = dto.inscricao;
            this.inscricaoAntes = JSON.parse(JSON.stringify(this.inscricao));
            this.candidato = this.inscricao.id.usuario.nome;
            this.inscricao.salaExtra = this.inscricao.salaExtra ? "Sim" : "Não";
            this.inscricao.atendimento_especial = this.inscricao.atendimento_especial
                                                                ? {label:"Sim",value:true}
                                                                : {label:"Não",value:false};
            this.inscricao.concorreVagasReservadas = this.inscricao.concorreVagasReservadas
                                                                ? {label:"Sim",value:true}
                                                                : {label:"Não",value:false};
            this.inscricao.nomeArea = this.inscricao.area.area.nome;
            this.inscricao.isentoPagamento = this.inscricao.isentoPagamento == undefined ? false : this.inscricao.isentoPagamento;
            this.selectedEstado = this.inscricao.estadoInscricao;
            this.inscricaoDialog = true;
            this.messages = [];
            this.$store.state.dlgLoading = false;
          });
    },
    findIndexById(identificador) {
      let index = -1;
      for (let i = 0; i < this.inscricoes.length; i++) {
        if (this.inscricoes[i].identificador === identificador) {
          index = i;
          break;
        }
      }
      return index;
    },

    exportCSV() {
      this.$store.state.dlgLoading = true;
      this.inscricaoService.exportarInscricoesCSV(this.processo.id, "Inscricoes")
          .then(() => this.$store.state.dlgLoading = false )
          .catch((erro) => {
            const status = erro.response ? ` (${erro.response.status})` : "";
            this.$toast.add({
              severity: "error",
              summary: "Erro",
              detail: `Nao foi possivel exportar aa planilha${status}. Verifique se a versao da API publicada possui essa rota.`,
              life: 5000,
            });
            this.$store.state.dlgLoading = false;
          })
    },

    setMensagem(estado) {
      // console.log(`this.selectedEstado: ${JSON.stringify(estado)}`);
      this.inscricao.mensagem = this.mensagens[estado.cod];
      this.onAlterarConcorrerVagasReservadas(estado);
    },

    download(identificador, tituloArquivo) {
      // console.log("identificador: ", identificador);

      var url = `inscricao/download/${identificador}`;

      http({
        url: url,
        method: "GET",
        responseType: "blob",
      }).then((reponse) => {
        const fileBlob = new Blob([reponse.data]);

        const fileUrl = window.URL.createObjectURL(fileBlob);

        const fileLink = document.createElement("a");
        fileLink.href = fileUrl;

        fileLink.setAttribute(
          "download",
          `${tituloArquivo}-${this.inscricao.codInscricao}-${this.inscricao.candidato}.pdf`
        );
        fileLink.setAttribute("target", "_blank");

        document.body.appendChild(fileLink);

        fileLink.click();
      });
    },

    setInscricoesByEstado() {
      this.inscricoesByEstado = [];

      for (let estadoInscricao of this.estados) {
        let inscricoes = this.inscricoes ? this.inscricoes.filter( (val) => val.estadoInscricao.cod == estadoInscricao.cod ) : [];
        inscricoes = inscricoes ? inscricoes : [];
        this.inscricoesByEstado[estadoInscricao.cod] = inscricoes;
      }

    },

    getTotalInscricoes() {
      return this.inscricoes ? this.inscricoes.length : 0;
    },

    getAreas(selecaoId) {
      this.areaService.getAreaProcesso(selecaoId).then((data) => {
        this.listaArea = data;
        console.log(data);
      });
    },

    onAlterarConcorrerVagasReservadas(estado) {
      if (this.inscricaoAntes.concorreVagasReservadas && (this.inscricao.concorreVagasReservadas.value != this.inscricaoAntes.concorreVagasReservadas) && estado.cod == 2) {
        this.inscricao.mensagem = this.mensagemAlterarDeficiencia;
      }
    }
  },
};
</script>

<style scoped lang="scss">
.table-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.product-image {
  width: 100px;
  box-shadow: 0 3px 6px rgba(0, 0, 0, 0.16), 0 3px 6px rgba(0, 0, 0, 0.23);
}

.p-dialog .product-image {
  width: 150px;
  margin: 0 auto 2rem auto;
  display: block;
}

.confirmation-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.product-badge {
  border-radius: 2px;
  padding: 0.25em 0.5rem;
  text-transform: uppercase;
  font-weight: 700;
  font-size: 12px;
  letter-spacing: 0.3px;

  &.status-instock {
    background: #c8e6c9;
    color: #256029;
  }

  &.status-outofstock {
    background: #ffcdd2;
    color: #c63737;
  }

  &.status-lowstock {
    background: #feedaf;
    color: #8a5340;
  }
}

@media screen and (max-width: 960px) {
  .p-datatable {
    &.p-datatable-customers {
      .p-datatable-thead > tr > th,
      .p-datatable-tfoot > tr > td {
        display: none !important;
      }

      .p-datatable-tbody > tr {
        border-bottom: 1px solid var(--surface-d);

        > td {
          text-align: left;
          display: block;
          border: 0 none !important;
          width: 100% !important;
          float: left;
          clear: left;
          border: 0 none;

          .p-column-title {
            padding: 0.4rem;
            min-width: 30%;
            display: inline-block;
            margin: -0.4rem 1rem -0.4rem -0.4rem;
            font-weight: bold;
          }

          .p-progressbar {
            margin-top: 0.5rem;
          }
        }
      }
    }
  }

  .p-toolbar {
    flex-wrap: wrap;

    .p-button {
      margin-bottom: 0.25rem;
    }
  }
}

.p-disabled-radio {
  background-color: #c63737;
  text-shadow: #c63737;
  color: #ced4da;
}
</style>
